<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="row">
              <!-- <div class="col-lg-3 col-md-3 dataListStatus">
                <ul>
                  <li><h4>TASK STATUS</h4></li>
                  <li class="cp" (click)="getAllTask()">ALL TASKS<span class="New">{{Total_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('NEW')">NEW <span class="New">{{NEW_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('ASSIGNED')">ASSIGNED <span class="Work-In-Progress">{{ASSIGNED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('REASSIGNED')">REASSIGNED <span class="Pending">{{REASSIGNED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('WORK_IN_PROGRESS')">WORK_IN_PROGRESS <span class="Completed">{{WORK_IN_PROGRESS_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('PENDING')">PENDING <span class="Deferred">{{PENDING_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('COMPLETED')">COMPLETED <span class="Deferred">{{COMPLETED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('DEFERRED')">DEFERRED <span class="Deferred">{{DEFERRED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('PARTIALLY_COMPLETED')">PARTIALLY_COMPLETED <span class="Deferred">{{PARTIALLY_COMPLETED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('FORCE_CLOSED')">FORCE_CLOSED <span class="Deferred">{{FORCE_CLOSED_tasksCount}}</span></li>
                  <li class="cp" (click)="getTasksByStatus('CLOSED')">CLOSED <span class="Deferred">{{CLOSED_tasksCount}}</span></li>
                </ul>
              </div> -->
              <div class="col-lg-12 col-md-12 dataList" style="margin:0;padding: 0;">
                <div class="dataList-header">
                  <div class="dataList-header-left">
                    <h4> DELETE TASK</h4>
                  </div>
                  <div class="dataList-header-right">
                    <input type="text" placeholder="Filter here" (keyup)="taskFilterByWildSearch(search.value)" #search [(ngModel)]="searchFilter">
                    <!-- <button data-toggle="modal" (click)="clearForm()" data-target="#exampleModal">Add Task</button> -->
                    <button (click)="searchclear()">Reset</button>

                  </div>
                </div>
                <div class="dataList-content">
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 5%;">#</th>
                        <th style="width: 20%;">Name</th>
                        <th style="width: 75%;">Description</th>
                        <th style="width: 10%;">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let task of tasks | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                      };let i = index">
                        <td>{{i+1}}</td>
                        <td>{{task.name}}</td>
                        <td>{{task.description}}</td>
                        <td>
                          <svg xmlns="http://www.w3.org/2000/svg" (click)="del(task.id)" data-toggle="modal" data-target="#deleteModal"    width="18" height="18" fill="currentColor" class="bi bi-trash3" viewBox="0 0 16 16">
                            <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"/>
                          </svg>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="pagination-block" *ngIf="tasks.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
                  <div *ngIf="tasks.length == 0">
                    <p class="text-center">No records found.</p>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteModalLabel">Confirmation
            <span data-dismiss="modal">
              <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </span>
          </h5>
        </div>
        <div class="modal-body">
          <p>are you sure? want to delete??</p>   
        <div class="modal-footer">
          <button type="button" id="closeModalButton1"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="deleteTask()" class="btn btn-primary">Delete</button>
        </div>
      </div>
    </div>
  </div>
</div>
